import {VideoSlideStreamFooterDefaultBox} from "./video-slides-stream-footer-default.box";

export const VideoSlideStreamFooterBox = VideoSlideStreamFooterDefaultBox;